import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/services/auth.service';
import { PayCode, PayCodes } from 'src/app/core/models/pay-codes.model';
import { TimeCode, TimeCodes } from 'src/app/core/models/time-codes.model';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor(
		private storage: LocalStorageService,
		private authService: AuthService,
	) { }

	async getCurrentUserTimeCodes(): Promise<TimeCode[]> {
		const userId = await this.authService.getCurrentUserId();
		const codes = (await this.getTimeCodes(userId))?.codes;

		return codes.sort((a, b) => a.desc > b.desc ? 1 : -1);
	}

	async getTimeCodes(userId: number): Promise<TimeCodes> {
		return await this.storage.timeCodes.getItem<TimeCodes>(userId);
	}

	async getCurrentUserPayCodes(): Promise<PayCode[]> {
		const userId = await this.authService.getCurrentUserId();

		return (await this.getPayCodes(userId))?.codes;
	}

	async getPayCodes(userId: number): Promise<PayCodes> {
		return await this.storage.payCodes.getItem<PayCodes>(userId);
	}

	async clearTimeCodesTable(): Promise<void> {
		await this.storage.timeCodes.clear();
	}

	async clearPayCodesTable(): Promise<void> {
		await this.storage.payCodes.clear();
	}
}
